const getTranslations = () => {
    const translations = document.getElementById("translations").value;
    return JSON.parse(translations);
};

const getCrops = () => {
    const crops = document.getElementById("crops").value;
    return crops ? JSON.parse(crops) : null;
};

const getCurrentLanguage = () => {
    const currentLanguage = document.getElementById("currentLanguage").value;
    return JSON.parse(currentLanguage);
};

export { getTranslations, getCrops, getCurrentLanguage };
